import React from 'react';
import { Gift, Plane } from 'lucide-react';
import { useScrollTrigger } from './hooks/useScrollTrigger';

const RegistrySection = () => {
  const [headerRef, headerVisible] = useScrollTrigger();
  const [heartCardRef, heartCardVisible] = useScrollTrigger();
  const [registryCardsRef, registryCardsVisible] = useScrollTrigger();

  return (
    <div className="max-w-5xl mx-auto px-6 py-12">
      <div 
        ref={headerRef}
        className={`text-center mb-16 transition-all duration-1000 ${
          headerVisible 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-8'
        }`}
      >
        <Gift className="mx-auto mb-6 text-[#F36C3D]" size={40} />
        <h2 className="text-4xl font-serif font-light text-[#7A3E53] mb-4">Gift Registry</h2>
      </div>

      <div 
        ref={heartCardRef}
        className={`max-w-3xl mx-auto text-center mb-20 transition-all duration-1000 ${
          heartCardVisible 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="p-10 border border-[#E76C9B]/20 rounded-2xl bg-white/80 shadow-sm hover:shadow-lg transition-all duration-500">
          <p className="text-[#5A8E6E] text-2xl mb-8 leading-relaxed font-medium">
            Your presence at our wedding is the greatest gift we could ever ask for! We truly need nothing more than your love and support as we begin this new chapter together.
          </p>
          <p className="text-[#5A8E6E] text-lg mb-8 leading-relaxed">
            If you would like to bless us further, we would be so grateful for a contribution toward our honeymoon — helping us create memories that will last a lifetime.
          </p>
        </div>
      </div>

      <div 
        ref={registryCardsRef}
        className={`flex justify-center max-w-4xl mx-auto transition-all duration-1000 ${
          registryCardsVisible 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-8'
        }`}
      >
        <div 
          className="p-10 border border-[#9B4F96]/20 rounded-2xl bg-white/80 shadow-sm text-center hover:shadow-lg transition-all duration-500"
          style={{ transitionDelay: registryCardsVisible ? '400ms' : '0ms' }}
        >
          <Plane className="mx-auto mb-6 text-[#9B4F96]" size={40} />
          <h3 className="text-2xl font-serif font-light text-[#7A3E53] mb-6">Honeymoon Fund</h3>
          <p className="text-[#5A8E6E] mb-8">
            Contributions can be made via EFT
          </p>
          <div 
            className={`mt-8 text-left transition-all duration-700 ${
              registryCardsVisible 
                ? 'opacity-100' 
                : 'opacity-0'
            }`}
            style={{ transitionDelay: registryCardsVisible ? '800ms' : '0ms' }}
          >
            <h4 className="font-serif text-[#7A3E53] mb-4">Banking details:</h4>
            <ul className="text-[#5A8E6E] space-y-2">
              {[
              { "text": "Bank: Nedbank", "color": "text-[#F36C3D]", "value": "Nedbank" },
               { "text": "Account Number: 118 028 3856", "color": "text-[#F36C3D]", "value": "118 028 3856" },
               { "text": "Branch Code: 198765",   "color": "text-[#E76C9B]", "value": "198765" },
               { "text": "Account Type: Cheque",  "color": "text-[#9B4F96]", "value": "Cheque" },
               { "text": "Account Holder: GJ de Kort","color": "text-[#F7C843]", "value": "GJ de Kort" }
              ].map((item, index) => (
                <li 
                  key={index}
                  className={`flex items-center hover:text-[#7A3E53] transition-colors duration-300 ${
                    registryCardsVisible 
                      ? 'opacity-100 translate-x-0' 
                      : 'opacity-0 translate-x-4'
                  }`}
                  style={{ transitionDelay: registryCardsVisible ? `${1000 + index * 100}ms` : '0ms' }}
                >
                  <span className={`mr-2 ${item.color}`}>•</span> {item.text}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrySection;